import { render, staticRenderFns } from "./Permits.vue?vue&type=template&id=8021c42e&scoped=true"
import script from "./Permits.vue?vue&type=script&lang=js"
export * from "./Permits.vue?vue&type=script&lang=js"
import style0 from "./Permits.vue?vue&type=style&index=0&id=8021c42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8021c42e",
  null
  
)

export default component.exports